import type { DcoInterface } from 'sonata-static-storage/lib/schemas/dco/dco.schema';
import type { TagItem } from '@/components/common/FormExpandableSection/FormExpandableSection';

export function getDCOTags(dco: DcoInterface): TagItem[] {
  if (!dco.enabled) {
    return [];
  }
  const filteredScenarios = dco.scenarios?.filter(s => !s.removed) ?? [];
  if (filteredScenarios.length === 0) {
    return [{ label: 'Enabled' }];
  }
  return [{ label: `${filteredScenarios.length} contexts` }];
}
